import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { addGuardiansWithEmail, updateGuardianPermissions } from '../helpers/registrationHelper';
import Errors from './errors';
import Checkbox from './checkbox';

class GuardianModal extends React.Component {

  constructor(props) {
    super(props)
    const { guardian, isNewGuardian } = props;

    this.state = {
      guardian: guardian,
      showModal: false,
      alerts: false,
      history: false,
      data: false,
      shouldHideModal: false,
      isNewGuardian: isNewGuardian,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.handleAddGuardian = this.handleAddGuardian.bind(this);
    this.handleUpdateGuardianPermissions = this.handleUpdateGuardianPermissions.bind(this);
  }

  componentDidMount() {
    if (this.state.guardian) {
      this.setState({ alerts: this.state.guardian.notification, data: this.state.guardian.data_visible })
    }
  }

  toggleModal(e) {

    if (e.target.id === "Cancel" || e.target.id === "Submit" && !this.state.showModal) {
      this.setState({ showModal: false, data: false, alerts: false, history: false, errorsMsgs: [], email: '' });
    } else {
      this.setState(prevState => ({ showModal: !prevState.toggleModal }));
    }
  }

  handleAddGuardian() {
    addGuardiansWithEmail(this.state.email, this.state.data, this.state.alerts)
      .then((response) => {
        if (!response.data.error) {
          const { saveGuardian, saveSuccessMsg } = this.props;
          saveSuccessMsg("Guardian added successfully");
          saveGuardian(response.data);
          this.setState({ data: false, alerts: false, history: false, showModal: false, errorsMsgs: [] });
        } else {
          this.setState({ errorsMsgs: [response.data.error], showModal: true });
        }
      })

  }

  handleUpdateGuardianPermissions() {
    updateGuardianPermissions(this.state.guardian.id, this.state.data, this.state.alerts)
      .then(response => {
        if (!response.data.error) {
          const { saveSuccessMsg } = this.props;
          saveSuccessMsg("Follower updated successfully");
          this.setState({ showModal: false })
        } else {
          this.setState({ errorsMsgs: [response.data.error], shouldHideModal: false })
        }
      })
      .catch(error => {
        console.log(error)
      })
    console.log(this.state)
  }

  handleCheckboxes(type) {
    if (type === 'data') {
      this.setState(prevState => ({ data: !prevState.data }))
    } else if (type === 'history') {
      this.setState(prevState => ({ history: !prevState.history }))
    } else if (type === 'alerts') {
      this.setState(prevState => ({ alerts: !prevState.alerts }))
    }
  }

  updateEmail(e) {
    this.setState({ email: e.target.value });
  }

  getModalBody() {
    return (
      <ReactModal
        isOpen={this.state.showModal}
        contentLabel="Followers Modal"
        className="follower-modal"
        ariaHideApp={false}>
        {
          this.state.isNewGuardian &&
          <h3>Add Guardians </h3>
        }
        {
          !this.state.isNewGuardian &&
          <h3>{"Edit Follower's permissions"} </h3>
        }
        {
          this.state.errorsMsgs && this.state.errorsMsgs.length > 0 &&
          <Errors errorsMsgs={this.state.errorsMsgs} />
        }
        {
          this.state.isNewGuardian &&
          <div>
            <input type="text" onChange={(e) => { this.updateEmail(e) }} placeholder="Enter the guardian's email" />
          </div>
        }

        {
          this.state.guardian && !this.state.isNewGuardian &&
          <div>
            <input type="text" disabled placeholder="Enter the Follower's email" value={this.state.guardian.email} />
          </div>
        }

        <div className="authorizations">
          <h4>Authorizations</h4>

          <Checkbox
            checked={this.state.alerts}
            handleCheckboxes={() => this.handleCheckboxes("alerts")}
            label={"Receive Alerts"}
          />

          <Checkbox
            checked={this.state.history}
            handleCheckboxes={() => this.handleCheckboxes("history")}
            label={"View my medical history"}
          />

          <Checkbox
            checked={this.state.data}
            handleCheckboxes={() => this.handleCheckboxes("data")}
            label={"View my Helo data"}
          />

        </div>
        <div className="buttonContainer">
          <button id="Cancel" className="secondaryBtn"
            onClick={(e) => {
              this.toggleModal(e)
            }}
          >Cancel</button>
          {
            this.state.isNewGuardian &&
            <button id="Submit" className="primaryBtn" onClick={this.handleAddGuardian}>Save</button>
          }
          {
            this.state.guardian && !this.state.isNewGuardian &&
            <button id="Submit" className="primaryBtn" onClick={this.handleUpdateGuardianPermissions}>Update</button>
          }
        </div>
      </ReactModal>)
  }

  render() {
    if (this.state.isNewGuardian) {
      return (
        <span>
          <div className="guardian">
            <div className="guardian-circle" id="addGuardian" onClick={(e) => { this.toggleModal(e) }}>
              +
          {this.getModalBody()}
            </div>
            <span>Add more friends</span>
          </div>
        </span>
      );
    } else {
      return (
        <div className="editBtn-container">
          <button onClick={(e) => { this.toggleModal(e) }}>Edit</button>
          {this.getModalBody()}
        </div>
      )
    }

  }
}

GuardianModal.propTypes = {
  show: PropTypes.bool,
  isNewGuardian: PropTypes.bool,
  children: PropTypes.node,
  guardians: PropTypes.object,
  guardian: PropTypes.object,
  saveGuardian: PropTypes.func,
  saveSuccessMsg: PropTypes.func,
  successMsg: PropTypes.string
};

export default GuardianModal;


// WEBPACK FOOTER //
// ./src/components/guardianModal.js